module.exports = __webpack_public_path__ + "static/image/font/pc/baemin-geullim-3.ver2_0_2.jpg?de82408a";